// TODO(mauriceyap): remove this in favour of custom hooks using @tanstack/react-query
import { getErrorMessage } from "../../common/utils"
import { JobSet } from "../../models/lookoutModels"
import { appendAuthorizationHeaders } from "../../oidcAuth"
import { ApiJobState, SubmitApi } from "../../openapi/armada"

export interface CancelJobSetsResponse {
  cancelledJobSets: JobSet[]
  failedJobSetCancellations: {
    jobSet: JobSet
    error: string
  }[]
}

export interface ReprioritizeJobSetsResponse {
  reprioritizedJobSets: JobSet[]
  failedJobSetReprioritizations: {
    jobSet: JobSet
    error: string
  }[]
}

export class UpdateJobSetsService {
  constructor(private submitApi: SubmitApi) {}

  async cancelJobSets(
    queue: string,
    jobSets: JobSet[],
    states: ApiJobState[],
    reason: string,
    accessToken?: string,
  ): Promise<CancelJobSetsResponse> {
    const response: CancelJobSetsResponse = { cancelledJobSets: [], failedJobSetCancellations: [] }
    for (const jobSet of jobSets) {
      try {
        const headers = new Headers()
        if (accessToken) {
          appendAuthorizationHeaders(headers, accessToken)
        }

        await this.submitApi.cancelJobSet(
          {
            body: {
              queue: queue,
              jobSetId: jobSet.jobSetId,
              filter: {
                states: states,
              },
              reason: reason,
            },
          },
          { headers },
        )
        response.cancelledJobSets.push(jobSet)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        const text = await getErrorMessage(e)
        response.failedJobSetCancellations.push({ jobSet: jobSet, error: text })
      }
    }
    return response
  }

  async reprioritizeJobSets(
    queue: string,
    jobSets: JobSet[],
    newPriority: number,
    accessToken?: string,
  ): Promise<ReprioritizeJobSetsResponse> {
    const response: ReprioritizeJobSetsResponse = { reprioritizedJobSets: [], failedJobSetReprioritizations: [] }

    for (const jobSet of jobSets) {
      try {
        const headers = new Headers()
        if (accessToken) {
          appendAuthorizationHeaders(headers, accessToken)
        }

        const apiResponse = await this.submitApi.reprioritizeJobs(
          {
            body: {
              queue: queue,
              jobSetId: jobSet.jobSetId,
              newPriority: newPriority,
            },
          },
          { headers },
        )
        if (apiResponse == null || apiResponse.reprioritizationResults == null) {
          const errorMessage = "No reprioritizationResults found in response body"
          // eslint-disable-next-line no-console
          console.error(errorMessage)
          response.failedJobSetReprioritizations.push({
            jobSet: jobSet,
            error: "No reprioritizationResults found in response body",
          })
          continue
        }

        let errorCount = 0
        let successCount = 0
        let error = ""
        for (const e of Object.values(apiResponse.reprioritizationResults)) {
          if (e !== "") {
            errorCount++
            error = e
          } else {
            successCount++
          }
        }
        if (errorCount === 0) {
          response.reprioritizedJobSets.push(jobSet)
        } else {
          const message = `Reprioritized: ${successCount}  Failed: ${errorCount}  Reason: ${error}`
          response.failedJobSetReprioritizations.push({ jobSet: jobSet, error: message })
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        const text = await getErrorMessage(e)
        response.failedJobSetReprioritizations.push({ jobSet: jobSet, error: text })
      }
    }
    return response
  }
}
